// Scroll helpers used throughout the app.
// Smooth scroll keeps things calm and avoids the uncomfortable jumps the user reported.

import { logger } from "@/lib/logger";

export function scrollToTop(opts = {}) {
  if (typeof window === "undefined") return;
  // honor reduced motion
  const prefersReduced = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  const behavior = opts.smooth === false || prefersReduced ? "auto" : "smooth";
  const delay = typeof opts.delay === "number" ? opts.delay : 60;
  window.setTimeout(() => {
    try {
      window.scrollTo({ top: 0, behavior });
    } catch (err) {
      // Old browsers don't support the options object; fall back to numeric API
      logger.warn("scrollToTop: window.scrollTo(options) unsupported, falling back", err?.message);
      window.scrollTo(0, 0);
    }
  }, delay);
}

export function scrollToElement(target, opts = {}) {
  if (typeof window === "undefined") return;
  const prefersReduced = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  const behavior = opts.smooth === false || prefersReduced ? "auto" : "smooth";
  const delay = typeof opts.delay === "number" ? opts.delay : 60;
  const offset = typeof opts.offset === "number" ? opts.offset : 80; // sticky header
  window.setTimeout(() => {
    try {
      const node = typeof target === "string" ? document.querySelector(target) : target;
      if (!node) return;
      const rect = node.getBoundingClientRect();
      const top = (rect.top + window.scrollY) - offset;
      window.scrollTo({ top: Math.max(0, top), behavior });
    } catch (err) {
      logger.warn("scrollToElement failed", err?.message);
    }
  }, delay);
}
